import React from 'react'

import { Icon } from 'components/Elements'

export const Mark = ({ className }) => {
  return <Icon className={'font-size-12 text-primary'} name={'circle'} />
}
